/* ATOZ TOYS GALLERY — vanilla JS
   Interactions: sticky header, mega menu, mobile nav, hero slider,
   announcement rotator, product sliders, wishlist, cart drawer,
   search overlay, FAQ accordion, filter collapse, newsletter,
   back-to-top, quick-add micro-interaction.
*/
(function () {
    'use strict';

    /* ---------- helpers ---------- */
    const $ = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
    const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

    /* ---------- sticky header ---------- */
    const header = $('.site-header');
    const onScroll = () => {
        if (!header) return;
        header.classList.toggle('is-scrolled', window.scrollY > 8);
        const top = $('.to-top');
        if (top) top.classList.toggle('is-visible', window.scrollY > 400);
    };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();

    /* ---------- announcement rotator ---------- */
    const slides = $$('.announcement-slider .a-slide');
    if (slides.length > 1) {
        let i = 0;
        setInterval(() => {
            slides[i].classList.remove('is-active');
            i = (i + 1) % slides.length;
            slides[i].classList.add('is-active');
        }, 3800);
    }

    /* ---------- mega menu (click-to-open on touch) ---------- */
    $$('.nav-item.has-mega > .nav-link').forEach(link => {
        on(link, 'click', (e) => {
            if (window.matchMedia('(hover: none)').matches) {
                e.preventDefault();
                const item = link.parentElement;
                $$('.nav-item.is-open').forEach(n => { if (n !== item) n.classList.remove('is-open'); });
                item.classList.toggle('is-open');
            }
        });
    });
    on(document, 'click', (e) => {
        if (!e.target.closest('.nav-item.has-mega')) {
            $$('.nav-item.is-open').forEach(n => n.classList.remove('is-open'));
        }
    });

    /* ---------- mobile nav ---------- */
    const burger = $('.burger');
    const mnav = $('.mobile-nav');
    const overlay = $('#overlay');
    const openMobile = () => { mnav && mnav.classList.add('is-open'); overlay && overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const closeMobile = () => { mnav && mnav.classList.remove('is-open'); document.body.style.overflow = ''; if (!$('.drawer.is-open') && !$('.search-overlay.is-open')) overlay && overlay.classList.remove('is-open'); };
    on(burger, 'click', openMobile);
    on($('.mobile-nav-close'), 'click', closeMobile);

    /* ---------- hero slider ---------- */
    const heroSlides = $$('.hero .hero-slide');
    const heroDots = $$('.hero-dots button');
    let heroIdx = 0, heroTimer;
    const goHero = (n) => {
        heroIdx = (n + heroSlides.length) % heroSlides.length;
        heroSlides.forEach((s, i) => s.classList.toggle('is-active', i === heroIdx));
        heroDots.forEach((d, i) => d.classList.toggle('is-active', i === heroIdx));
    };
    const startHero = () => { clearInterval(heroTimer); heroTimer = setInterval(() => goHero(heroIdx + 1), 6000); };
    if (heroSlides.length) {
        heroDots.forEach((d, i) => on(d, 'click', () => { goHero(i); startHero(); }));
        startHero();
    }

    /* ---------- product sliders (arrow scroll) ---------- */
    $$('[data-slider]').forEach(slider => {
        const scroller = $('.products-scroller', slider);
        const prev = $('[data-prev]', slider);
        const next = $('[data-next]', slider);
        if (!scroller) return;
        const step = () => Math.min(scroller.clientWidth * 0.9, 900);
        on(prev, 'click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
        on(next, 'click', () => scroller.scrollBy({ left: step(), behavior: 'smooth' }));
    });

    /* ---------- wishlist toggles ---------- */
    const wishCount = $('[data-wish-count]');
    let wish = 0;
    $$('.wish').forEach(btn => {
        on(btn, 'click', (e) => {
            e.preventDefault(); e.stopPropagation();
            btn.classList.toggle('is-active');
            wish += btn.classList.contains('is-active') ? 1 : -1;
            if (wish < 0) wish = 0;
            if (wishCount) { wishCount.textContent = wish; wishCount.style.display = wish ? 'inline-flex' : 'none'; }
        });
    });
    if (wishCount) wishCount.style.display = 'none';

    /* ---------- cart drawer + quick add ---------- */
    const cartDrawer = $('#cart-drawer');
    const cartCount = $('[data-cart-count]');
    const cartList = $('[data-cart-list]');
    const cartEmpty = $('[data-cart-empty]');
    const cartTotalEl = $('[data-cart-total]');
    const cart = [];

    const renderCart = () => {
        if (!cartList) return;
        cartList.innerHTML = cart.map((c, i) => `
      <li class="cart-line" data-i="${i}">
        <div class="cart-thumb" style="background:${c.color};"></div>
        <div class="cart-meta">
          <strong>${c.title}</strong>
          <small>Qty ${c.qty}</small>
        </div>
        <span class="cart-price">$${(c.price * c.qty).toFixed(2)}</span>
      </li>`).join('');
        const total = cart.reduce((s, c) => s + c.price * c.qty, 0);
        if (cartTotalEl) cartTotalEl.textContent = '$' + total.toFixed(2);
        if (cartCount) cartCount.textContent = cart.reduce((s, c) => s + c.qty, 0);
        const empty = cart.length === 0;
        if (cartEmpty) cartEmpty.style.display = empty ? 'flex' : 'none';
        if (cartList) cartList.style.display = empty ? 'none' : 'block';
    };
    renderCart();

    const openDrawer = (el) => { el.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const closeDrawer = (el) => {
        el.classList.remove('is-open');
        document.body.style.overflow = '';
        if (!$('.drawer.is-open') && !$('.mobile-nav.is-open') && !$('.search-overlay.is-open')) overlay.classList.remove('is-open');
    };

    $$('[data-open-cart]').forEach(b => on(b, 'click', () => openDrawer(cartDrawer)));
    $$('.drawer-close').forEach(b => on(b, 'click', () => { const d = b.closest('.drawer'); if (d) closeDrawer(d); }));
    on(overlay, 'click', () => {
        $$('.drawer.is-open').forEach(closeDrawer);
        closeMobile();
        const so = $('.search-overlay.is-open'); if (so) so.classList.remove('is-open');
        overlay.classList.remove('is-open'); document.body.style.overflow = '';
    });

    /* ---------- Quick Add (Shopify AJAX) ---------- */
    $$('.quick-add-form').forEach(form => {
        on(form, 'submit', (e) => {
            e.preventDefault();
            const btn = $('.quick-add', form);
            const originalText = btn.textContent;
            btn.textContent = 'Adding...';
            btn.disabled = true;

            const formData = new FormData(form);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (!response.ok) throw new Error('Error adding to cart');
                return response.json();
            })
            .then(item => {
                btn.textContent = 'Added ✓';
                // Here we would typically fetch the updated cart object
                // fetch('/cart.js').then(r => r.json()).then(cart => renderCart(cart))
                openDrawer(cartDrawer);
                setTimeout(() => {
                    btn.textContent = originalText;
                    btn.disabled = false;
                }, 1200);
            })
            .catch(error => {
                console.error('Error:', error);
                btn.textContent = 'Error';
                setTimeout(() => {
                    btn.textContent = originalText;
                    btn.disabled = false;
                }, 1200);
            });
        });
    });

    /* ---------- search overlay ---------- */
    const searchOverlay = $('.search-overlay');
    $$('[data-open-search]').forEach(b => on(b, 'click', () => {
        searchOverlay.classList.add('is-open');
        overlay.classList.add('is-open');
        setTimeout(() => $('.search-box input')?.focus(), 100);
    }));
    on($('.search-close'), 'click', () => { searchOverlay.classList.remove('is-open'); overlay.classList.remove('is-open'); });
    on(document, 'keydown', (e) => {
        if (e.key === 'Escape') {
            searchOverlay?.classList.remove('is-open');
            $$('.drawer.is-open').forEach(closeDrawer);
            closeMobile();
            overlay?.classList.remove('is-open');
            document.body.style.overflow = '';
        }
    });

    /* ---------- FAQ accordion ---------- */
    $$('.faq-item .faq-q').forEach(q => {
        on(q, 'click', () => q.parentElement.classList.toggle('is-open'));
    });

    /* ---------- Filter groups collapse ---------- */
    $$('.filter-group h5').forEach(h => {
        on(h, 'click', () => h.parentElement.classList.toggle('is-collapsed'));
    });

    /* ---------- Newsletter validation ---------- */
    const nlForm = $('#newsletter-form');
    on(nlForm, 'submit', (e) => {
        e.preventDefault();
        const input = $('input[type="email"]', nlForm);
        const msg = $('.msg', nlForm.parentElement);
        const v = input.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
            msg.textContent = 'Please enter a valid email address.';
            msg.style.color = '#ffe0dc';
            return;
        }
        msg.textContent = 'Thank you — welcome to the ATOZ family ▲ ● Z';
        msg.style.color = '#fff';
        input.value = '';
    });

    /* ---------- Back to top ---------- */
    on($('.to-top'), 'click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

    /* ---------- View toggle (collection) ---------- */
    $$('.view-toggle button').forEach(b => {
        on(b, 'click', () => {
            $$('.view-toggle button').forEach(x => x.classList.remove('is-active'));
            b.classList.add('is-active');
            const grid = $('.products-grid');
            if (!grid) return;
            if (b.dataset.view === 'list') grid.classList.add('is-list');
            else grid.classList.remove('is-list');
        });
    });

    /* ---------- Reveal on scroll (subtle) ---------- */
    const io = ('IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
        entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 }) : null;
    if (io) $$('[data-reveal]').forEach(el => io.observe(el));
})();
